import apps from "../../apps";

/**
 * @param {Object[]} [users]
 * @param {String}   [lsKey]
 *
 * @return {Object}
 */
export default function getMockStrategy(users, lsKey = "user") {
  /* eslint-disable camelcase */
  users = users || [{
    uid: "95d11184-ed3f-4e30-9caf-a49feb560ee4",
    email: "martin.catty@delegateip.com",
    password: "Valipat01",
    roles: ["admin"],
    first_name: "Martin",
    last_name: "Catty",
    default_portfolio_uid: "95931d42-72fb-4e40-b82e-fa6a306dffd7",
    portfolios: [
      {
        full_view: false,
        uid: "95931d42-72fb-4e40-b82e-fa6a306dffd7",
        full_name: "Valipat S.A. - EUR",
        short_name: "Valipat S.A. - EUR",
        currency: "EUR"
      },
      {
        full_view: false,
        uid: "7aab2886-00d8-454a-8b5d-425fcab9b110",
        full_name: "Valipat S.A. - USD",
        short_name: "Valipat S.A. - USD",
        currency: "USD"
      }
    ]
  }];
  /* eslint-enable camelcase */

  return {
    /**
     * @return {Promise}
     */
    getConnectedUser() {
      const user = localStorage.getItem(lsKey);

      return Promise.resolve(user ? JSON.parse(user) : null);
    },

    /**
     * @param {String} email
     * @param {String} password
     *
     * @return {Promise}
     */
    login(email, password) {
      const user = users.find(user => user.email === email && user.password === password);

      if (user) {
        localStorage.setItem(lsKey, JSON.stringify(user));
      }

      return Promise.resolve(user || null);
    },

    /**
     * @return {Promise}
     */
    logout() {
      localStorage.removeItem(lsKey);

      return Promise.resolve();
    },

    /**
     * @return {Array}
     */
    getMockedUsers() {
      return users;
    },

    /**
     * @return {Promise}
     */
    getApps() {
      return Promise.resolve(apps);
    }
  };
}
